import {ChangeDetectionStrategy, Component, Directive, Input, ViewEncapsulation} from '@angular/core'
import {slideAnimation} from '../../../core/animation/slide'

@Directive({
  selector: '[feFeatureAction]',
  host: {'class': 'fe-feature-action'}
})
export class FeatureActionsDirective {
}

@Component({
  selector: 'fe-feature',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="fe-feature_title">
      {{label}}
      <ng-content select="[feFeatureAction]"></ng-content>
    </div>
    <div class="fe-feature_body" *ngIf="isOpen" [@slide]>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./question-feature.component.scss'],
  animations: [slideAnimation],
})
export class QuestionFeatureComponent {

  @Input() label: string

  @Input() isOpen = false
}
